module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.154/css/toolsmenu.css"